// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeMevoV2__contentWrap__rs4IU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConsentTypeMevoV2/ConsentTypeMevoV2.css
// module id = 3131
// module chunks = 0